import { sysConfig } from '../config'
export const BASE_URL = process.env.NODE_ENV==='production' ? "/api/v1" :`${sysConfig.BACKEND_URI}:${sysConfig.BACKEND_PORT}/api/v1`